import axios from 'axios'

// VITE_API_URL is the backend root (e.g. http://localhost:3001).
// All endpoints live under /api, so we append that suffix.
// When no env var is present (e.g. production build behind a proxy) we fall back to /api.
const apiRoot = import.meta.env.VITE_API_URL
export const baseURL = apiRoot ? `${apiRoot}/api` : '/api'

// Plain axios instance — no auth interceptor.
// Token injection is handled per-request via useAuthedApi() hook.
export const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
})
